'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Immutable = require('Immutable');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimezoneGroup = function (_Record) {
  _inherits(TimezoneGroup, _Record);

  function TimezoneGroup() {
    _classCallCheck(this, TimezoneGroup);

    return _possibleConstructorReturn(this, (TimezoneGroup.__proto__ || Object.getPrototypeOf(TimezoneGroup)).apply(this, arguments));
  }

  _createClass(TimezoneGroup, [{
    key: 'timezoneForMomentTimezone',
    value: function timezoneForMomentTimezone(timezone) {
      return this.timezones.find(function (tz) {
        return tz.momentTimezones.includes(timezone);
      });
    }
  }]);

  return TimezoneGroup;
}((0, _Immutable.Record)({
  groupName: '',
  timezones: (0, _Immutable.List)()
}));

exports.default = TimezoneGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/timezone-utils/static-2.97/js/records/TimezoneGroup.js
// module id = 469
// module chunks = 0